import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import { Video } from '../../types';
import NeonBorder from '../NeonBorder/NeonBorder';
import styles, { COMPETITION_BORDER } from './style';

interface VideoStatusPillProps {
  video: Video;
}

// Status of the video, like the app: "Top N" after its weekly ranking, "En compétition" during its week.
const VideoStatusPill: React.FC<VideoStatusPillProps> = React.memo((props) => {
  const { video } = props;
  const { t } = useTranslation();

  if (video.top >= 1) {
    return (
      <Box component="span" sx={styles.top}>
        {t('admin.feed.top', { top: video.top })}
      </Box>
    );
  }
  if (video.weeklyRanking) {
    return (
      // In competition: a light in the colors of the ranks runs around the pill (like the app).
      <Box component="span" sx={styles.competition}>
        {t('admin.feed.inCompetition')}
        <NeonBorder borderWidth={COMPETITION_BORDER} />
      </Box>
    );
  }
  return null;
});

export default VideoStatusPill;
